import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const pushProxy: RouteRecordItem = {
  path: '/proxy/push',
  name: 'ProxyPush',
  component: LAYOUT,
  redirect: { name: 'PushProxy' },
  meta: {
    orderNo: 9,
    icon: 'mdi:proxy',
    title: t('routes.pushProxy.推流代理'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'detail',
      name: 'PushProxy',
      component: () => import('@/pages/stream-proxy/push.vue'),
      meta: {
        title: t('routes.pushProxy.推流代理'),
      },
    },
  ],
}

export default pushProxy
